import { Box, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import List, { HeadCell } from 'components/list/list';

import React from 'react';
import ChileOpenSlotRow from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/chile/chile-open-slot-row';
import ChileOrderRow from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/chile/chile-order-row';
import { useOrderRows } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/hooks/use-order-rows';
import { isActiveOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/order-utils';

type Props = { filters: string[] };

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders.list';

const ChileOrdersList: FC<Props> = ({ filters }) => {
  const intl = useIntl();
  const theme = useTheme();
  const { rows, isLoading } = useOrderRows(filters, true);

  const columns: HeadCell[] = [
    {
      id: 'orderStatus',
      align: 'center',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.orderNumber` }),
    },
    {
      id: 'customerOrderReference',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.customerOrderReference` }),
      sx: { whiteSpace: 'nowrap' },
    },
    {
      id: 'changes',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.changes` }),
    },
    {
      id: 'deliveryDate',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.deliveryDate` }),
    },
    {
      id: 'quantity',
      align: 'right',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.quantity` }),
    },
    {
      id: 'actions',
      label: '',
      align: 'right',
    },
  ];

  return (
    <>
      <Box display={'flex'} justifyContent={'center'} gap={2} alignItems={'center'}>
        <Typography>
          <FormattedMessage id={`${PAGE_NAME_ID}.manual`} />
        </Typography>
        <Box borderBottom={`1px solid ${theme.palette.darkBlue.o25}`} width={'100%'} />
      </Box>
      <List
        options={columns}
        isLoading={isLoading}
        noResult={{
          show: !rows.length,
          text: intl.formatMessage({ id: `general.noResults` }),
        }}>
        {rows.map((row, idx) =>
          isActiveOrder(row) ? <ChileOrderRow key={idx} order={row} /> : <ChileOpenSlotRow key={idx} openSlot={row} />
        )}
      </List>
    </>
  );
};

export default React.memo(ChileOrdersList);
